module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [(_vm.noTenant) ? _c('Erro500', {
    attrs: {
      "erro": _vm.noTenant
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.$route.meta.disablePageHeader && !_vm.loadingContent && _vm.$root.$session.usuario.logged && _vm.$root.$session.usuario.logged.point) ? _c('div', [_c('EmpresaHeader')], 1) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent) ? _c('div', {
    staticClass: "pl-3 pr-3 pb-3",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row "
  }, [(!_vm.$route.meta.disablePageHeader) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$route.meta.title.toUpperCase()))]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": this.$root.$session.navigation
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.noTenant && !_vm.loadingContent && _vm.$root.$session.cliente.logged) ? _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('EmpresaFooter')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4752120"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/empresa.vue
// module id = 1600
// module chunks = 45